RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const PanelTitle = Marionette.ItemView.mixin({
        template: '#dashboardWidgetPngPanelTitleTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        serializeData: function () {
            const me = this;

            return {
                title: me.dashboardModel.getTitle(),
                subtitle: me.dashboardModel.getSubtitle()
            };
        },
        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        }
    });

    views.PngPanel = views.Panel.extend({
        panelTitleView: PanelTitle
    });

    views.NoHeadingPngPanel = App.views.PngPanel.extend({
        template: '#dashboardWidgetPanelNoHeadingTemplate',
        onRender: function () {
            const me = this;
            me.showContent();
        },
        serializeData: _.noop
    });
});
